<template>
    
    <div class="row">

        <div class="col-md-6">
            <!-- Form Input -->
            <div class="form-group">
                <label for="tipo_proyecto_id">Tipo de proyecto:</label>
                <select name="tipo_proyecto_id" v-model="tipo_proyecto_id" class="form-control" @change="ActualizaTipoProyecto" :required="obligatorio">
                    <option value="">Seleccione tipo de proyecto</option>
                    <option v-for="tp in tipos_proyecto" :value="tp.id" :key="'tipo_proyecto-' + tp.id">{{ tp.nombre }}</option>
                </select>
            </div>
        </div>

        <div class="col-md-6">
            <!-- Form Input -->
            <div class="form-group">
                <label for="programa_proyecto_id">Programa:</label>
                <select v-if="programas.length > 0" name="programa_proyecto_id" v-model="programa_proyecto_id" class="form-control" :required="obligatorio">
                    <option value="">Seleccione programa</option>
                    <option v-for="programa in programas" :value="programa.id" :key="'programa-' + programa.id">{{ programa.nombre }}</option>
                </select>
                <select v-else class="form-control" :required="obligatorio">
                    <option value="">No hay programas disponibles</option>
                </select>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        data() {
            return {
                programa_proyecto_id: null,
                programas: [],
                tipo_proyecto_id: null,
                tipos_proyecto: [],
            }
        },
        props: {
            prop_programa_proyecto_id: {required: false, default: null},
            prop_tipo_proyecto_id: {required: false, default: null},
            obligatorio: {required: false, default: false},
        },
        mounted() {
            this.CargarTiposProyecto();
        },
        methods: {
            ActualizaTipoProyecto() {
                this.CargarProgramasProyecto();
            },
            CargarProgramasProyecto(programa_proyecto_id = null) {
                const self = this;
                self.programa_proyecto_id = '';

                if(self.tipo_proyecto_id){
                    const tipo_proyecto = self.tipos_proyecto.find(tp => tp.id == self.tipo_proyecto_id);
                    if(!tipo_proyecto)
                        return;

                    window.axios
                        .get('/data/tipos-proyecto/' + tipo_proyecto.slug + '/programas-proyecto')
                        .then(function(response){

                            self.programas = response.data.programas;

                            if(programa_proyecto_id)
                                self.programa_proyecto_id = programa_proyecto_id;
                            
                        })
                        .catch(function (error) {
                            window.NotificarError(error);
                        });
                }
            },
            CargarTiposProyecto() {
                const self = this;
                
                window.axios
                    .get('/data/tipos-proyecto')
                    .then(function(response){

                        self.tipos_proyecto = response.data.tipos_proyecto;

                        if(self.prop_tipo_proyecto_id) {
                            self.tipo_proyecto_id = self.prop_tipo_proyecto_id;
                            self.CargarProgramasProyecto(self.prop_programa_proyecto_id);
                        }

                    })
                    .catch(function (error) {
                        window.NotificarError(error);
                    });
            }
        }
    }
</script>
